import React, {Component} from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames';
import './star.css';


class Star extends Component {

    render() {

        const starClass = classNames({
            'Star': true,
            'Star--active': this.props.active,
        });

        return (
            <div className={starClass} onClick={this.props.onClick}>
                <svg viewBox="0 0 42 40.287">
                    <defs>

                        <radialGradient id="radial-gradient" cx="0.5" cy="0.5" r="0.5"
                                        gradientUnits="objectBoundingBox">
                            <stop offset="0" stopColor="#dfdfdf"/>
                            <stop offset="1" stopColor="#b5b5b5"/>
                        </radialGradient>
                        <radialGradient id="radial-gradient-filled" cx="0.5" cy="0.5" r="0.604" gradientTransform="translate(0.023 -0.017) scale(0.953 1.034)" gradientUnits="objectBoundingBox">
                            <stop offset="0" stopColor="#d6d25d"/>
                            <stop offset="1" stopColor="#b2ae32"/>
                        </radialGradient>
                        <clipPath id="clip-path">
                            <rect id="Rectangle_181" data-name="Rectangle 181" className="Star__inside" width="42"
                                  height="40.287"/>
                        </clipPath>
                    </defs>
                    <g
                        className="Star__wrap"
                        transform="translate(-830.144 -541)"
                    >
                        <path
                            id="Path_167"
                            data-name="Path 167"
                            className="Star__inside"
                            d="M2837.167,566.5l-2,13.333,12-6.333,12,6.333-2.333-13.333,9.667-9.667-13.333-2-6-12.333-6.333,12.333-13.5,2Z"
                            transform="translate(-1996)"
                        />
                        <g
                            id="Group_149"
                            data-name="Group 149"
                            transform="translate(830.144 541)"
                        >
                            <g id="Group_148" data-name="Group 148" className="Star__outside__group">
                                <path
                                    id="Path_163"
                                    data-name="Path 163"
                                    className="Star__outside"
                                    d="M41.9,15.86a1.188,1.188,0,0,0-.937-.8L27.861,13.2,21.968,1.346a1.164,1.164,0,0,0-2.09.011L14.059,13.242.957,15.2A1.153,1.153,0,0,0,.02,16a1.132,1.132,0,0,0,.3,1.185l9.5,9.212L7.637,39.446A1.169,1.169,0,0,0,8.1,40.588a1.118,1.118,0,0,0,.679.226,1.059,1.059,0,0,0,.539-.14l11.7-6.2L32.753,40.6a1.2,1.2,0,0,0,.539.129,1.173,1.173,0,0,0,1.164-1.164,1.086,1.086,0,0,0-.032-.269L32.161,26.322l9.449-9.266a1.141,1.141,0,0,0,.291-1.2ZM30.092,25.094a1.123,1.123,0,0,0-.323,1.034L31.74,37.442,21.547,32.119a1.177,1.177,0,0,0-1.088,0l-10.15,5.387,1.907-11.335a1.167,1.167,0,0,0-.334-1.024L3.64,17.153l11.367-1.692a1.166,1.166,0,0,0,.873-.636L20.933,4.5l5.118,10.29a1.159,1.159,0,0,0,.884.636l11.378,1.616Zm0,0"
                                    transform="translate(0.034 -0.625)"
                                />
                            </g>
                        </g>
                    </g>
                </svg>
            </div>
        );
    }
}

Star.propTypes = {
    active: PropTypes.bool.isRequired,
    id: PropTypes.number.isRequired,
    onClick: PropTypes.func.isRequired,
}

export default Star;



// WEBPACK FOOTER //
// ./src/components/star/index.js